<template>
  <div class="wrap" id="box">
    <div class="middle">
      <svg style="position: absolute" width="100%" height="250">
        <defs>
          <mask id="mask3">
            <rect x="0" y="0" width="100%" height="100%" style="stroke: none; fill: #ccc"></rect>

            <circle v-for="(item, index) in circles" :key="index" :cx="item.cx" :cy="item.cy" :r="item.cw" style="fill: #000" />
          </mask>
        </defs>
        <rect x="0" y="0" width="100%" height="100%" style="stroke: none; mask: url(#mask3)"></rect>
      </svg>

      <!-- top: `calc(${item.cy}% - ${item.r}px)`,  -->
      <div @click="handlePointClick(index)" class="point" :class="activeIndex === index && 'point_light'" v-for="(item, index) in circles" :key="index + 10" :style="{
          top: `${item.cy - item.p / 2}px`,
          left: `${item.cx - item.p / 2}px`,
          width: `${item.cw}px`,
          height: `${item.cw}px`,
        }">
        <div class="plus">+</div>
      </div>
      <img :src="url" alt="" />

      <!-- <span
        v-for="item in point"
        :key="item.cy"
        :style="{
          position: 'absolute',
          display: 'block',
          top: `${item.cy}%`,
          left: `${item.cx}%`,
          width: `${item.cw}px`,
          height: `${item.ch}px`,
          borderRadius: '50%',
        }"
      ></span> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      default: "",
      type: String,
    },
    fileId: {
      default: "",
      type: String,
    },
  },
  data () {
    return {
      urls: [
        "https://api.ascod.cn/iotUser-api/camera/20210909/20210909083503.jpg",
        "https://api.ascod.cn/iotUser-api/camera/20210909/20210909083508.jpg",
        "https://api.ascod.cn/iotUser-api/camera/20210909/20210909083454.jpg",
        "https://app01.ascod.cn/static/test/20211021090647.jpg",
        "https://app01.ascod.cn/static/test/20211021090643.jpg",
        "https://app01.ascod.cn/static/test/20211021090609.jpg",

        // 成熟期的 7张图片
        "https://api.ascod.cn/static-camera/20211209/20211209134121.jpg",
        "https://api.ascod.cn/static-camera/20211209/20211209134147.jpg",
        "https://api.ascod.cn/static-camera/20211209/20211209134130.jpg",
        "https://api.ascod.cn/static-camera/20211209/20211209134126.jpg",
        "https://api.ascod.cn/static-camera/20211209/20211209134137.jpg",
        "https://api.ascod.cn/static-camera/20211209/20211209134107.jpg",
        "https://api.ascod.cn/static-camera/20211209/20211209134142.jpg",
      ],
      activeIndex: 0,
      xy: [
        [
          { cx: "0.3600", cy: "118" },
          { cx: "0.4100", cy: "116" },
          { cx: "0.4320", cy: "59" },
          { cx: "0.5740", cy: "54" },
          { cx: "0.8100", cy: "68" },
          { cx: "0.8080", cy: "210" },
          { cx: "0.6840", cy: "201" },
        ],
        [
          { cx: "0.0520", cy: "246" },
          { cx: "0.1800", cy: "229" },
          { cx: "0.5420", cy: "80" },
          { cx: "0.5460", cy: "107" },
          { cx: "0.6380", cy: "174" },
          { cx: "0.7140", cy: "164" },
          { cx: "0.9860", cy: "154" },
          { cx: "0.7440", cy: "80" },
        ],
        [
          { cx: "0.2292", cy: "63" },
          { cx: "0.4766", cy: "85" },
          { cx: "0.5755", cy: "55" },
          { cx: "0.8594", cy: "60" },
          { cx: "0.4297", cy: "158" },
          { cx: "0.5469", cy: "157" },
        ],
        [
          { cx: "0.2240", cy: "70", r: "20" },
          { cx: "0.4766", cy: "85", r: "20" },
          { cx: "0.5755", cy: "55", r: "20" },
          { cx: "0.8594", cy: "60", r: "20" },
          { cx: "0.4297", cy: "158", r: "20" },
          { cx: "0.5469", cy: "157", r: "20" },
        ],
        [
          { cx: "0.0720", cy: "163", r: "10" },
          { cx: "0.0640", cy: "153", r: "10" },
          { cx: "0.1040", cy: "146", r: "10" },
          { cx: "0.1360", cy: "136", r: "10" },
          { cx: "0.1120", cy: "260", r: "10" },
          { cx: "0.1460", cy: "246", r: "10" },
          { cx: "0.2420", cy: "237", r: "10" },
          { cx: "0.2960", cy: "245", r: "10" },
          { cx: "0.3480", cy: "210", r: "10" },
          { cx: "0.5160", cy: "125", r: "10" },
          { cx: "0.5440", cy: "124", r: "10" },
          { cx: "0.4820", cy: "102", r: "10" },
          { cx: "0.5900", cy: "69", r: "10" },
          { cx: "0.6000", cy: "101", r: "10" },
          { cx: "0.7460", cy: "85", r: "10" },
          { cx: "0.6840", cy: "169", r: "10" },
          { cx: "0.5900", cy: "240", r: "10" },
          { cx: "0.5060", cy: "226", r: "10" },
          { cx: "0.5900", cy: "192", r: "10" },
          { cx: "0.5300", cy: "255", r: "10" },
          { cx: "0.8460", cy: "185", r: "10" },
        ],
        [
          { cx: "0.7000", cy: "16", r: "20" },
          { cx: "0.7200", cy: "77", r: "20" },
          { cx: "0.8980", cy: "92", r: "20" },
          { cx: "0.8980", cy: "210", r: "20" },
          { cx: "0.7900", cy: "195", r: "20" },
          { cx: "0.5960", cy: "120", r: "20" },
          { cx: "0.5460", cy: "118", r: "20" },
          { cx: "0.5660", cy: "90", r: "20" },
          { cx: "0.4560", cy: "76", r: "20" },
          { cx: "0.4240", cy: "217", r: "20" },
          { cx: "0.7000", cy: "252", r: "20" },
        ],

        // 成熟期的 7张图片
        // 成熟期的 7张图片
        // 成熟期的 7张图片
        // 成熟期的 7张图片
        // 成熟期的 7张图片
        // 1
        [
          { cx: "0.0680", cy: "80", r: "25" },
          { cx: "0.5547", cy: "126", r: "50" },
        ],
        // 2
        [
          { cx: "0.3151", cy: "81", r: "35" },
          { cx: "0.6224", cy: "136", r: "35" },
        ],
        // 3
        [
          { cx: "0.2630", cy: "111", r: "10" },
          { cx: "0.2839", cy: "118", r: "10" },
          { cx: "0.3125", cy: "147", r: "10" },
          { cx: "0.4401", cy: "77", r: "10" },
          { cx: "0.4531", cy: "87", r: "10" },
          { cx: "0.5365", cy: "123", r: "10" },
          { cx: "0.5547", cy: "137", r: "10" },
          { cx: "0.4740", cy: "180", r: "10" },
          { cx: "0.6458", cy: "102", r: "10" },
          { cx: "0.6302", cy: "78", r: "10" },
          { cx: "0.6875", cy: "36", r: "10" },
        ],
        // 4
        [{ cx: "0.6146", cy: "138", r: "90" }],

        // 5
        [
          { cx: "0.0365", cy: "88", r: "10" },
          { cx: "0.3568", cy: "48", r: "10" },
          { cx: "0.5130", cy: "35", r: "10" },
        ],
        // 6
        [
          { cx: "0.3099", cy: "122", r: "15" },
          { cx: "0.5938", cy: "77", r: "15" },
          { cx: "0.1797", cy: "29", r: "15" },
        ],
        // 7
        [{ cx: "0.5573", cy: "30", r: "15" }],
      ],
      circles: [],
      point: [],
      imgUrl: "",
      realWidth: 0,
      realHeight: 0,
      imgWidth: 0,
      imgHeight: 0,
    };
  },

  mounted () {
    // window.addEventListener('click', function (e) {
    //   const height = 384
    //   const percent = (e.pageX - 15) / height
    //   console.log('e:', percent.toFixed(4), e.pageY - 15)
    // })

    this.$nextTick(() => {
      const img = document.getElementsByTagName("img")[0];
      this.imgWidth = img.offsetWidth;
      this.imgHeight = img.offsetHeight;

      this.handleAIScan();
      const that = this;
      const image = new Image();
      image.src = this.url;
      image.onload = async function () {
        console.log("图片真实宽高：", image.width, image.height);
        await that.getData(image.width, image.height);
        // await that.test(image.width, image.height);
      };
    });
  },

  methods: {
    test (realWidth, realHeight) {
      const data = [
        {
          width: 105,
          height: 110,
          left: 531,
          top: 114,
        },
        {
          height: 126,
          left: 811,
          top: 387,
          width: 122,
        },
        {
          height: 118,
          left: 868,
          top: 478,
          width: 98,
        },
        {
          height: 125,
          left: 598,
          top: 375,
          width: 127,
        },
        {
          height: 114,
          left: 755,
          top: 439,
          width: 109,
        },
      ];
      const point = [];
      const imgWidth = this.imgWidth;
      const imgHeight = this.imgHeight;

      console.log("imgWidth:", imgWidth, imgHeight, realWidth, realHeight);
      data.map((item) => {
        let { height, left, top, width } = item;
        //  压缩的比列
        const pW = imgWidth / realWidth;
        const pH = imgHeight / realHeight;
        const cx = (left / realWidth) * imgWidth;
        const cy = (top / realHeight) * imgHeight;
        const cw = pW * width;
        const ch = pH * height;

        point.push({
          cx,
          cy,
          cw,
          ch,
        });
      });

      console.log("point:", point);
      this.point = point;
    },

    async getData (realWidth, realHeight) {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });


      const params = {
        fileId: Number(this.fileId),
        imgUrl: this.url
      }

      if (!params.fileId) {
        delete params.fileId
      } else {
        delete params.imgUrl
      }


      await this.$api.checkFruitPosition(params).then((res) => {
        if (res.errcode === 0) {
          const data = res.results;

          // 拿到图片真实的宽高
          // 拿到图片被压缩后的宽高
          const point = [];
          data.map((item) => {
            let { height, left, top, width } = item.location;

            //  压缩的比列
            const pW = this.imgWidth / realWidth;
            const pH = this.imgHeight / realHeight;
            const cx = pW * left;
            const cy = pH * top;
            const cw = pW * width;
            const ch = pH * height;

            point.push({
              cx: cx + Math.max(cw, ch) / 2,
              cy: cy + Math.max(cw, ch) / 2,
              cw: Math.max(cw, ch) / 1.5,
              ch: Math.max(cw, ch) / 1.5,
              p: Math.max(cw, ch) / 1.5,
            });
          });

          console.log("point:", point);
          this.point = [...point];
          this.circles = [...point];
        } else {
          this.$toast.fail({
            message: res.errmsg,
          });
        }
      });
      setTimeout(() => {
        this.$toast.clear();
      }, 1500);
    },

    handlePointClick (index) {
      this.activeIndex = index;
    },

    // 点击识别
    async handleAIScan () {
      this.$nextTick(() => {
        const len = 50;
        const pointBox = document.getElementsByClassName("point");

        const deg = 360 / len;
        try {
          for (let i = 0; i < pointBox.length; i++) {
            const pointBoxItem = pointBox[i];
            const w = Number(pointBoxItem.style.width.slice(0, 2));
            for (var j = 0; j < len; j++) {
              let tys = [-8, -14, -20];

              if (w >= 40) {
                tys = [-10, -18, -30];
              } else if (w < 40 && w > 20) {
                tys = [-8, -14, -20];
              } else if (w < 20) {
                tys = [-6];
              }

              for (let k = 0; k < tys.length; k++) {
                const ty = tys[k];

                //添加div
                var cbox = document.createElement("div");
                cbox.className = "point_box";
                cbox.style.cssText =
                  "transform:rotate(" +
                  deg * j +
                  "deg) translateY(" +
                  ty +
                  "px) ";
                if (k === 0) {
                  cbox.style.background = "rgba(88, 199, 236, 0.2)";
                } else if (k === 1) {
                  cbox.style.background = "rgba(88, 199, 236, 0.4)";
                } else if (k === 2) {
                  cbox.style.background = "rgba(88, 199, 236, 0.6)";
                }

                cbox.style.top = Number(this.circles[i].r) - 1 + "px";
                cbox.style.left = `calc(${this.circles[i].cx}%  `;

                // pointBoxItem.appendChild(cbox)

                // 实心边框
                // var bigBorBox = document.createElement('div')
                // bigBorBox.className = 'big_bor_box'
                // // var smallBorBox = document.createElement('small_bor_box')
                // bigBorBox.style.width = Number(this.circles[i].r) * 2 - 4 + 'px'
                // bigBorBox.style.height =
                //   Number(this.circles[i].r) * 2 - 4 + 'px'

                // // smallBorBox.style.width = Number(this.circles[i].r) - 8 + 'px'
                // // smallBorBox.style.width = Number(this.circles[i].r) - 8 + 'px'
                // pointBoxItem.appendChild(bigBorBox)
                // // pointBoxItem.appendChild(smallBorBox)
              }
            }
          }
        } catch (e) {
          console.error(e);
        }
      });

      this.activeIndex = 0;
    },
  },
};
</script>

<style>
.point_box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1px;
  height: 2px;
  background: rgba(88, 199, 236, 0.5);
  z-index: 1000;
}

.big_bor_box,
.small_bor_box {
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  border-radius: 50%;
}

.big_bor_box {
  border: 0.5px solid rgba(88, 199, 236, 0.5);
  border-left: 0.5px solid transparent;
  border-bottom: 0.5px solid transparent;
}
</style>

<style scoped lang="scss">
.wrap {
  width: 100%;
  height: 100%;
  background: #000;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 10;
  overflow-y: scroll;
  padding: 0 !important;
}

.wrap_top {
  position: relative;
  display: flex !important;
  justify-content: center !important;
  text-align: center !important;
  height: 60px;
  align-items: center;
  color: #ffffff;
  z-index: 1001;
  box-sizing: border-box;

  .close {
    position: absolute;
    right: 20px;
    top: 18px;
    font-size: 20px;
  }
}

.middle {
  position: relative;
  width: 100%;
  z-index: 1000;

  img {
    width: 100%;
    height: 250px;
    border-radius: 2px;
  }

  .point {
    position: absolute;
    border-radius: 50%;
    z-index: 100000;
    background: rgba(37, 41, 42, 0.7);

    // background: url("./../../assets/images/AI_target.svg") 100% no-repeat;
    // background-size: cover;
  }

  .point_light {
    background: rgba(0, 0, 0, 0.000001);
  }

  .time {
    text-align: center;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 20px;
  }

  .plus {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(88, 199, 236, 0.2);
  }
}
</style>
